import NetworkedGroup from "users/entities/networked-group/networked-group";
import _ from "lodash";

export default class UpdateNetworkedGroupApiRequest {
  payload: { op: string; path: string; value: unknown }[] | null = null;

  constructor(
    originalGroup: NetworkedGroup,
    updatedGroup: NetworkedGroup
  ) {
    this.payload = [];

    // Simple value comparisons
    this.compareAndPush(updatedGroup, originalGroup, "name");
    this.compareAndPush(updatedGroup, originalGroup, "description");

    // Deep equality comparisons
    this.deepCompareAndPush(updatedGroup, originalGroup, "memberUserIds");
  }

  deepCompareAndPush(updatedGroup: NetworkedGroup, originalGroup: NetworkedGroup, key: keyof NetworkedGroup) {
    const updatedValue = updatedGroup[key];
    const originalValue = originalGroup[key];

    if (!_.isEqual(updatedValue, originalValue)) {
      this.payload?.push({
        op: "replace",
        path: `/${key}`,
        value: updatedValue
      });
    }
  }

  compareAndPush(updatedGroup: NetworkedGroup, originalGroup: NetworkedGroup, key: keyof NetworkedGroup) {
    const updatedValue = updatedGroup[key];
    const originalValue = originalGroup[key];

    if (updatedValue !== originalValue) {
      this.payload?.push({
        op: "replace",
        path: `/${key}`,
        value: updatedValue
      });
    }
  }
}
